import { AccessToken, OktaAuth, Token } from "@okta/okta-auth-js"

const environmentURL = import.meta.env.VITE_BASE_URL.toString()
const issuerURL = import.meta.env.VITE_OKTA_ISSUER_URL.toString()
const clientId = import.meta.env.VITE_OKTA_CLIENT_KEY.toString()

const oktaAuth = new OktaAuth({
	//issuer: `https://ermevo.oktapreview.com/oauth2/default/`,
	issuer: issuerURL,
	// clientId: `0oacmf8cdjgx4ArDY1d7`,
	// clientId: `0oaf17al26kO3j7C11d7`,
	clientId: clientId,
	// redirectUri: window.location.origin + '/user',
	redirectUri: environmentURL + "/login/callback",
	//  redirectUri: 'http://localhost:3000/login/callback',
	// redirectUri: 'https://web-eus-d-astraz.azurewebsites.net/login/callback',
	// scopes: ['openid', 'profile', 'email'],
	scopes: ["openid", "profile", "email", "offline_access"],
	pkce: true,
	// responseType is not needed with PKCE — code flow is automatic
	tokenManager: {
		autoRenew: true, // Automatically renew tokens before expiration
		expireEarlySeconds: 120, // Renew 120 seconds before expiration (increased from 60)
		storage: "localStorage", // Use localStorage to share tokens across tabs
	},
	storageManager: {
		transaction: {
			storageType: "sessionStorage", // PKCE code verifier must be per-tab to avoid cross-tab conflicts
		},
		cache: {
			storageType: "localStorage",
		},
	},
	services: {
		autoRenew: true, // Enable service-level auto renewal
		autoRemove: true, // Remove expired tokens
		syncStorage: true, // Sync tokens across tabs
	},
})

// Handle successful token renewal
oktaAuth.tokenManager.on("renewed", (key, token) => {
	console.log(`Token renewed: ${key}`)
	if (key === "accessToken") {
		let accessTokenData = token as AccessToken
		// Store in localStorage for cross-tab support
		localStorage.setItem("token", accessTokenData.accessToken)
	}
})

// Handle token expiration
oktaAuth.tokenManager.on("expired", (key, expiredToken) => {
	console.warn(`Token expired: ${key}`, expiredToken)
	// Attempt to renew the expired token
	oktaAuth.tokenManager.renew(key).catch((err) => {
		console.error(`Failed to renew ${key}:`, err)
		// If renewal fails, the error handler below will catch it
	})
})

// Handle token renewal errors
oktaAuth.tokenManager.on("error", (err) => {
	console.error("TokenManager error:", err)
	// Check if this is a critical error that requires re-authentication
	if (err.errorCode === "login_required" || err.name === "OAuthError") {
		console.log("User needs to re-authenticate")
		// Clear invalid tokens
		oktaAuth.tokenManager.clear()
		sessionStorage.clear()
		localStorage.removeItem("token")
		localStorage.removeItem("PersonSessionData")
		// Redirect to login
		window.location.href = "/login"
	}
})

// Start the Okta service to enable automatic token renewal
// This MUST be called for autoRenew to work
oktaAuth
	.start()
	.then(() => {
		//console.log("Okta Auth service started - token auto-renewal enabled")
	})
	.catch((error) => {
		console.error("Failed to start Okta Auth service:", error)
	})

export { oktaAuth }
